const staticToken =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiJhYzg0NTVjMy1iNDY4LTQ3NTItOTRhMi0yN2Q4ZjkyZTM2ZGQiLCJlbWFpbCI6ImFkYXJzaGJhbGlrYUBnbWFpbC5jb20ifQ.qNjloYzBD9dTsG9DRvXCKkI71x5wELUhDzE-RIuapZI";

export default staticToken;
